<div mat-dialog-content style="width: 60vw;">
  <div class="spinner-container" *ngIf="isLoading">
    <mat-spinner diameter="25"></mat-spinner>
  </div>
  <p>{{ rowData }}</p>
</div>
